/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Connectionstatus_Error1Inputs */



/**
* | output |
* | --- |
* | "Error" |
*
* @param {Alarms_Connectionstatus_Error1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_connectionstatus_error1 = /** @type {((inputs?: Alarms_Connectionstatus_Error1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Connectionstatus_Error1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Error")
	return /** @type {LocalizedString} */ ("Erreur")
});
export { alarms_connectionstatus_error1 as "alarms_connectionStatus_error" }